import React, { ReactElement } from 'react';
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// import Link from 'next/link';
import classNames from 'classnames/bind';
import { PitchTitleIcon } from 'sections/Benefits/svg';
import styles from 'sections/Benefits/Networking/components/SectionPitch/SectionPitch.module.scss';

const cn = classNames.bind(styles);

const SectionPitch = (): ReactElement => {
  return (
    <section className={cn('pitch')}>
      <div className={cn('container')}>
        <div className={cn('pitch__title-box')}>
          <h2 className={cn('pitch__title')}>
            {PitchTitleIcon}
            Why Network with DF Alliance?
          </h2>
          <p className={cn('pitch__title-description')}>
            Unlock unparalleled opportunities through our exclusive, verified community of logistics professionals.
          </p>
        </div>
        <div className={cn('pitch__paragraphs')}>
          <p className={cn('pitch__paragraph')}>
            At DF Alliance, we connect you with a meticulously vetted network of freight forwarders 
            spanning over 190 countries. Our platform facilitates seamless communication, 
            partnership opportunities, and access to shared resources, empowering you to deliver 
            world-class services to your customers and leverage your logistics business.
          </p>
        </div>
        {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
        {/* <div className={cn('pitch__button')}>
          <Link className={cn('pitch__button-join')} href="/membership">
            Join DFA Alliance Now
          </Link>
        </div> */}
      </div>
    </section>
  );
};

export default SectionPitch;